import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BottomSheet } from 'react-spring-bottom-sheet';
import { Box } from '@material-ui/core';
import LoginDialog from '../../Dialogs/LoginDialog';
import { closeLoginBlock } from '../../../redux/modules/loginBlock';
import useDeviceResize from '../../../hooks/useDeviceResize';
import LoginForm from '../../FormComponents/LoginForm';
import EfesLogo from '../../../img/efesLogoDarkWithText.png';

import useStyles from '../makeStyles';

const LoginWrapper = () => {
  const isDeviceLgSize = useDeviceResize('lg');
  const classes = useStyles();
  const dispatch = useDispatch();

  const isLoginBlockOpen = useSelector((state) => state.loginBlock.isOpen);

  const closeLogin = useCallback(() => {
    dispatch(closeLoginBlock());
  }, [dispatch]);

  if (isDeviceLgSize) {
    return (
      <BottomSheet open={isLoginBlockOpen} onDismiss={closeLogin} className={classes.root}>
        <Box p={2} pb={2}>
          <img src={EfesLogo} alt="logo" className={classes.logo} />
          <LoginForm />
        </Box>
      </BottomSheet>
    );
  }

  return <LoginDialog open={isLoginBlockOpen} onClose={closeLogin} />;
};

export default LoginWrapper;
